<div class="dialog-container">
  <div class="closewrapper">
    <div class="dialog-title-block">
      <div class="closealert text-heading-4">Close Alert?</div>
      <div class="closealertcontent">
        The Alert is “
        <ng-container *ngIf="cabinetName">
          <a (click)="cancel()" [routerLink]="['/home/stocks/cabinets', cabinetId]">
            <span class="cabinetclosecontent">{{ cabinetName }}</span>
          </a>
        </ng-container>
        <ng-container *ngIf="productName">
          <a (click)="cancel()" [routerLink]="['/home/stocks/products', cabinetId]">
            <span class="cabinetclosecontent">{{ productName }}</span>
          </a>
        </ng-container>
        Cabinet <span class="status-alert">{{ status }} - {{ count }}</span>” not fulfilled yet.
        Are you sure you want to close this?
      </div>
      <div class="updatealert-section">
        <button class="primary-btn updateno-content" (click)="cancel()">No</button>
        <button class="primary-btn close-content" (click)="confirmClose()">Yes, Close</button>
      </div>
    </div>
  </div>
</div>
